import { render, staticRenderFns } from "./CopySocialFinalResult.vue?vue&type=template&id=5dacc8d4"
import script from "./CopySocialFinalResult.vue?vue&type=script&lang=js"
export * from "./CopySocialFinalResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports